import { DEFAULT_LOCALE, isLocale } from "./locales.js";
// Parse an Accept-Language header value and return the best supported locale.
// Matches on the primary subtag (e.g. "en-GB" → "en"). Falls back to en.
export function negotiateLocale(acceptLanguage) {
    if (!acceptLanguage)
        return DEFAULT_LOCALE;
    const ranked = acceptLanguage
        .split(",")
        .map((part) => {
        // A language-range may carry params after the subtag, e.g.
        // "ar;q=0.9;level=1". Split on ";", take the subtag, then find the q
        // param among the rest — splitting only on ";q=" would fold trailing
        // accept-ext params into the q value and zero it out.
        const [rawTag, ...params] = part.trim().split(";");
        const qParam = params.map((p) => p.trim()).find((p) => p.startsWith("q="));
        const q = qParam ? Number(qParam.slice(2)) : 1;
        return {
            tag: (rawTag ?? "").trim().toLowerCase(),
            q: Number.isFinite(q) ? q : 0,
        };
    })
        .filter((entry) => entry.tag.length > 0)
        .sort((a, b) => b.q - a.q);
    for (const { tag } of ranked) {
        const primary = tag.split("-")[0];
        if (isLocale(primary))
            return primary;
    }
    return DEFAULT_LOCALE;
}
// Resolve an explicit locale (e.g. a ?locale= query param) first; if it is not
// a supported locale, fall back to Accept-Language negotiation, then en.
export function resolveLocale(explicit, acceptLanguage) {
    if (isLocale(explicit))
        return explicit;
    return negotiateLocale(acceptLanguage);
}
